import { describeHandler } from "../inspector.js";
import "./handler.js";
import { dispatchAction, focusNode } from "../tree/tree.js";
//#region src/handler/activate.ts
/**
* Navigation handler factory that creates a {@link NavigationHandler} that invokes callback when an activate action is received.
*
* @param onActivate - function that is called when node receives `activate` action
*
* @see {@link ActivateCallback}
* @see {@link https://fiveway.dev/guide/built-in-handlers#activation-handler}
* @see {@link NavigationHandler}
*/
const activationHandler = createActivationHandler;
function createActivationHandler(onActivate) {
	const activationHandler = (action, { next }) => {
		if (import.meta.env.FIVEWAY_INSPECTOR ?? import.meta.env.DEV) describeHandler(action, { name: "activate" });
		if (action.kind === "activate") {
			onActivate({ longpress: action.longpress });
			return null;
		}
		return next();
	};
	return activationHandler;
}
/**
* Activates a node by invoking the `activate` action on it.
*
* @see {@link ActivateNodeOptions} for options
* @see {@link ActivateAction}
*/
function activateNode(tree, nodeId, options) {
	if (options?.focus ?? true) focusNode(tree, nodeId);
	const action = {
		kind: "activate",
		longpress: options?.longpress
	};
	dispatchAction(tree, action, nodeId);
}
//#endregion
export { activateNode, activationHandler };

//# sourceMappingURL=activate.js.map